import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import {
  AuthTokenBundle,
  MfaDeliveryMethod,
  MfaStatusResponse,
  MfaVerifyResponse,
  WebauthnRegistrationOptions,
  WebauthnAuthenticationOptions,
} from "./dtos";

const MFA_VERIFICATION_SERVICE = `${Constants.API_URL}/bedrock/2fa`;
const MFA_SETTINGS_SERVICE = `${Constants.API_URL}/bedrock/mfa_settings`;
const PASSKEYS_SERVICE = `${Constants.API_URL}/bedrock/passkeys`;

export class MfaServices {
  // --- 2FA / Step-up Flow ---

  @scCatchServiceException()
  static async requestChallenge(deliveryMethod: MfaDeliveryMethod): Promise<MfaStatusResponse> {
    const { data } = await axios.post<MfaStatusResponse>(`${MFA_VERIFICATION_SERVICE}/challenge`, {
      delivery_method: deliveryMethod,
    });
    return data;
  }

  static async verifyChallenge(code: string, deliveryMethod: MfaDeliveryMethod): Promise<MfaVerifyResponse> {
    const { data } = await axios.post<MfaVerifyResponse>(
      `${MFA_VERIFICATION_SERVICE}/verify`,
      {
        code,
        delivery_method: deliveryMethod,
      },
      { skipAuthRedirect: true } as any
    );
    return data;
  }

  // --- MFA Settings ---

  @scCatchServiceException()
  static async updateMfaPhone(phone: string): Promise<MfaStatusResponse> {
    const { data } = await axios.post<MfaStatusResponse>(`${MFA_SETTINGS_SERVICE}/update_phone`, { phone });
    return data;
  }

  @scCatchServiceException()
  static async acceptSmsTos(): Promise<MfaStatusResponse> {
    const { data } = await axios.post<MfaStatusResponse>(`${MFA_SETTINGS_SERVICE}/accept_sms_tos`);
    return data;
  }

  // --- Passkeys (WebAuthn) ---

  @scCatchServiceException()
  static async getRegistrationChallenge(): Promise<WebauthnRegistrationOptions> {
    const { data } = await axios.get<WebauthnRegistrationOptions>(`${PASSKEYS_SERVICE}/registration_challenge`);
    return data;
  }

  @scCatchServiceException()
  static async verifyRegistration(webauthnParams: any, nickname?: string): Promise<MfaStatusResponse> {
    const { data } = await axios.post<MfaStatusResponse>(`${PASSKEYS_SERVICE}/registration_verify`, {
      ...webauthnParams,
      nickname,
    });
    return data;
  }

  @scCatchServiceException()
  static async getAuthChallenge(): Promise<WebauthnAuthenticationOptions> {
    const { data } = await axios.get<WebauthnAuthenticationOptions>(`${PASSKEYS_SERVICE}/auth_challenge`);
    return data;
  }

  @scCatchServiceException()
  static async verifyAuth(webauthnParams: any): Promise<MfaVerifyResponse> {
    const { data } = await axios.post<MfaVerifyResponse>(`${PASSKEYS_SERVICE}/auth_verify`, webauthnParams);
    return data;
  }
}
